import React from "react";
import { Helmet } from "react-helmet";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Link } from "react-router-dom";
import { arrowIcon,backArrow} from "./svg";

import {
  SiriMainWrapper,
  SiriPageTitle,
  SiriAssessementWrapper,
  SiriAsmtLeftWrap,
  SiriAsmtRightWrap,
  SiriCardWrap,
  SiriCard,
  CardLeftSec,
  TextWrap,
  StatusTab,
  TopProgressBar,
  ProgressBarSection,
  HeaderProgress,
  HeaderProgressBar,
  SubmitSection,
  AssessmentSubmissionSection,
  AsmtTopSec,
  AsmtBottomSec,
  ButtonSec,
  CardRightSec,
  ProgressBar,
  SiriMobileTitleContainer,
} from "./styles";
import { useEffect, useState } from "react";

export const SiriMainView = (props) => {
  
  const cardData=[
    {
      id: 1,
      dimension_name: 'Vertical Integration',
      status: 'todo'
    },
    {
      id: 2,
      dimension_name: 'Horizontal Integration',
      status: 'inprogress'
    },
    {
      id: 3,
      dimension_name: 'Product Lifecycle',
      status: 'validated'
    },
    {
      id: 4,
      dimension_name: 'Shopfloor Automation',
      status: 'todo'
    },
    {
      id: 5,
      dimension_name: 'Shopfloor Automation',
      status: 'todo'
    },
    {
      id: 6,
      dimension_name: 'Facility Automation',  
      status: 'todo'
    },
    {
      id: 7,
      dimension_name: 'Shopfloor Connectivity',
      status: 'todo'
    },
    {
      id: 8,
      dimension_name: 'Enterprise Connectivity',
      status: 'todo'
    },    
    {
      id: 9,
      dimension_name: 'Facilty Connectivity',
      status: 'todo'
    },
    {
      id: 10,
      dimension_name: 'Shopfloor Intelligence',
      status: 'todo'
    },
    {
      id: 11,
      dimension_name: 'Enterprise Intelligence ',
      status: 'todo'
    },
    {
      id: 12,
      dimension_name: 'Faculty Intelligence ',
      status: 'todo',
    },
    {
      id: 13,
      dimension_name: 'Workforce L&D ',
      status: 'todo',
    },    
    {
      id: 14,
      dimension_name: 'Leadership Competency ',
      status: 'todo',
    },
    {
      id: 15,
      dimension_name: 'Inter- & Intra- Company Collaboration',
      status: 'inprogress',
    },
    {
      id: 16,
      dimension_name: 'Strategy & Governance',
      status: 'todo',
    },
  ]
  return (
    <>        
    
    <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
    <BreadcrumbsItem to="#">SIRI Assessment</BreadcrumbsItem>
    <Helmet>
      <title>Siri Assessment | SmarterChains</title>
      <meta name="description" content="Siri Assessment" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
      
      <SiriMainWrapper data-component="SiriMainWrapper">
        <SiriPageTitle data-component="SiriPageTitle">SIRI Assessment</SiriPageTitle>
        <SiriMobileTitleContainer data-component="SiriMobileTitleContainer">
          <button className="back-icon" dangerouslySetInnerHTML={{ __html:  backArrow}}></button>
          <span>SIRI Assessment</span>
        </SiriMobileTitleContainer>
        <SiriAssessementWrapper data-component="SiriAssessementWrapper">
          <SiriAsmtLeftWrap data-component="SiriAsmtLeftWrap">
            <SiriCardWrap data-component="SiriCardWrap">
            {cardData.map((item, index) => (
              <SiriCard as={Link} data-component="SiriCard" to="/siri-dimension">
                <CardLeftSec data-component="CardLeftSec">
                  <span className="count">{index+1}</span>
                  <TextWrap data-component="TextWrap">
                    <span class="dimension-count">Dimension {index+1}</span>
                    <span className="dimension-name">{item.dimension_name}</span>
                  </TextWrap>
                </CardLeftSec>
                <CardRightSec data-component="CardRightSec">
                  <StatusTab data-component="StatusTab" status={item.status}>
                    {item.status==='todo'?'To Do':item.status==='inprogress'?'IN PROGRESS':item.status==='validated'?'VALIDATED':''}
                  </StatusTab>
                  <button className="icon-svg" dangerouslySetInnerHTML={{ __html:  arrowIcon}}></button>
                </CardRightSec>
              </SiriCard>
            ))}
            </SiriCardWrap>
          </SiriAsmtLeftWrap>
          <SiriAsmtRightWrap data-component="SiriAsmtRightWrap">
            <TopProgressBar data-component="TopProgressBar">
              <ProgressBarSection data-component="ProgressBarSection">
                <HeaderProgress data-component="HeaderProgress">
                  <p class="progress-title">Overall Progress:</p>
                  <h2>2%</h2>
                  <HeaderProgressBar data-component="HeaderProgressBar">
                    <ProgressBar data-component="ProgressBar" value={2}></ProgressBar>
                  </HeaderProgressBar>
                </HeaderProgress>
              </ProgressBarSection>
              <SubmitSection data-component="SubmitSection">
                <span class="heading">Dimensions Validated: </span>
                <div class="count">0 / 9</div>
              </SubmitSection>
            </TopProgressBar>
            <AssessmentSubmissionSection data-component="AssessmentSubmissionSection" active>
              <AsmtTopSec data-component="AsmtTopSec">
                <span class="progress-text">Download</span>
              </AsmtTopSec>
              <AsmtBottomSec data-component="AsmtBottomSec">
                <p>All the dimensions are validated, click the "Download Validate Table" button to download the validation in excel format.</p>
              </AsmtBottomSec>
              <ButtonSec data-component="ButtonSec">
                <button class="download-btn">Download Validate Table</button>
              </ButtonSec>
            </AssessmentSubmissionSection>
          </SiriAsmtRightWrap>
        </SiriAssessementWrapper>
      </SiriMainWrapper>
    </>
  );
};
 

 